import React from 'react';
import {
  chakra,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react';
import Post from 'shared/src/interfaces/Post.interface';
import {
  compose,
  max,
  required
} from 'web-react-ui/src/reactFinalForm/validators';
import TextArea from 'web-react-ui/src/reactFinalForm/fields/TextArea';

const ImageVariablesSection = ({ post }: { post: Post }) => {
  if (!post.imageFormVariables?.length) return null;
  return (
    <>
      <Heading fontSize="1.5em" pb="1em">Image Text</Heading>
      <Flex flexDirection="row" w="100%" gap="1em">
        <Flex flexDirection="column" w="100%" gap="1em">
          {
            post.imageFormVariables.map((v, index) => (
              <TextArea
                key={v.id}
                name={`imageFormVariables[${index}.value`}
                label={<Text textTransform="capitalize">{v.name}</Text>}
                validate={compose(required, max(v.maxLength))}
                info={`max ${v.maxLength}`}
                alwaysShowValidation
                wrapLabel
                chakra
              />
            ))
          }
        </Flex>
        <chakra.figure maxW="50%">
          <Image src={post?.output.media?.[0]} maxH="50em" />
          <chakra.figcaption textAlign="center">Current Image</chakra.figcaption>
        </chakra.figure>
      </Flex>
    </>
  );
};

export default ImageVariablesSection;
